<template>
  <transition name="fade" appear>
    <section @click="$emit('close')">
      <svg width="0" height="0" style="position: absolute">
        <defs>
          <clipPath id="planTypeFirst" clipPathUnits="objectBoundingBox">
            <path
              d="M0.895,0 H0 C0.023,0.006,0.068,0.03,0.068,0.085 V0.895 C0.067,0.921,0.083,1,0.187,1 H1 V0.093 C1,0.015,0.93,-0.001,0.895,0"
            />
          </clipPath>
          <clipPath id="planType" clipPathUnits="objectBoundingBox">
            <path
              d="M0.895,0 H0 C0.023,0.006,0.068,0.03,0.068,0.085 V1 H1 V0.093 C1,0.015,0.93,-0.001,0.895,0"
            />
          </clipPath>
        </defs>
      </svg>
      <div class="ui" :date-id="styleNames[props.type]">
        <PlanType
          @click.stop="$emit('close')"
          v-for="(plan, id) in filterTypes(
            plans[
              plans.findIndex(
                (element) => element.FullTitle === styleNames[props.type]
              )
            ]?.Types
          )"
          :per="props.type === 'multi-game-plans' && plan.Title !== 'Stadium Pass' ? 'Per Month' : 'Per Game'"
          to="Home"
          :key="plan.Title"
          :date="plan.LaunchDate"
          :first="id === 0"
          :image="plan.Image.path"
          :icon="plan.Icon.path"
          :title="plan.Title"
          :description="plan.Description"
          :starting="plan.StartingFrom"
          :link="plan.Link"
        />
      </div>
    </section>
  </transition>
</template>


<script>
export default {
  name: "PlanTypesModal",
  data: () => ({
    plans: [],
  }),
  watch: {
    "$store.state.plans"() {
      this.setPlans();      
    },
  },
  mounted() {
    this.setPlans();
  },
  methods: {
    setPlans() {
      let plans = this.$store.state.plans.filter((element) => {
        let show =
          element.LaunchDate === "" ||
          element.LaunchDate === null ||
          new Date(`${element.LaunchDate} EST`).getTime() <
            new Date().getTime();
        return show;
      });
      this.plans = plans;
    },
    filterTypes(types) {
      let filtered = [];
      if (types) {          
        filtered = types.filter((element) => {            
          let show =
            element.LaunchDate === "" ||
            element.LaunchDate === null ||
            new Date(`${element.LaunchDate} EST`).getTime() < new Date().getTime();
          return show;
        });
      }
      
      if(this.$route?.name === 'Reserve Membership' && filtered[0]?.Style) {        
        let special = {...filtered[0]};
        special.Title = 'Club Membership'
        special.Description = ''
        special.Link = special.PremiumPlanType.PremiumPlan[1].Title;
        special.StartingFrom = special.PremiumPlanType.PremiumPlan[1].StartingAt.substr(1)
        //console.log('so', special)
        filtered = [special]
      }
      
      return filtered;
    },
  },
};
</script>
<script setup>
import axios from "axios";
import { useStore } from "vuex";
import { ref } from "vue";
import PlanType from "@/components/PlanType";

const store = useStore();
const props = defineProps({
  type: String,
});
const styleNames = {
  single: "Single Game Tickets",
  "large-group": "Large Group Tickets",
  "multi-game-plans": "Multi-Game Plans",
};
</script>


<style lang="scss" scoped>
section {
    padding-top:0;
  display: flex;
  flex-direction: column;
  gap: 50px;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  max-height: 100vh;
  overflow: auto;
}
.ui {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  gap: 0;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  > * {
    flex-grow: 1;
    max-width: 300px;
  }
  @media (min-width: 1200px) {
    flex-direction: row;
  }
}
</style>